module.exports = __webpack_public_path__ + "static/img/s-apple-3.22a1ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s-apple-3.png
// module id = MG5+
// module chunks = 0